import type { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

/** A small rounded chip of the analytics dashboard: section filters and the chart filters mark. */
export const pillChipSx: SxProps<Theme> = {
  height: 32,
  borderRadius: '16px',
  bgcolor: Color.white,
  border: `1px solid ${Color.border}`,
  boxShadow: `0 1px 2px ${Color.shadowBlack016}`,
  fontSize: '0.8125rem',
  fontWeight: 500,
  color: 'text.primary',
  '& .MuiChip-label': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '& .MuiChip-icon, & .MuiChip-deleteIcon': {
    fontSize: '1.125rem',
    color: Color.textIcon,
  },
};
